import React, { useState } from "react";
import "./PopupGift.scss"; // Ensure this file contains the custom styles
import ConfirmPopup from "./ConfirmPopup";
import { createOrder } from "../api/apiServiceFetch"; // Assuming this is the correct import

const PopupGift = ({ isOpen, onClose, userId, setVip, isVip = false }) => {
	const [showPopup, setShowPopup] = useState(false);
	const [selectedOption, setSelectedOption] = useState("day"); // Default to week
	const [selectedGift, setSelectedGift] = useState("premium");
	const [selectedType, setSelectedType] = useState("день"); // Default to week
	const [count, setCount] = useState(1); // Default to 1
	const [superLikes, setSuperLikes] = useState(3); // Default to 0
	const [clean, setClean] = useState(1); // Default to 0
	const [extendEndDate, setExtendEndDate] = useState(true);

	const calculateEndDate = (plan, count) => {
		const currentDate = new Date();
		const intCount = parseInt(count, 10);
		switch (plan) {
			case "day":
				currentDate.setDate(currentDate.getDate() + intCount);
				break;
			case "week":
				currentDate.setDate(currentDate.getDate() + 7 * intCount);
				break;
			case "month":
				currentDate.setMonth(currentDate.getMonth() + intCount);
				break;
			case "year":
				currentDate.setFullYear(currentDate.getFullYear() + intCount);
				break;

			default:
				break;
		}
		return currentDate;
	};
	const handleConfirm = async () => {
		setShowPopup(true);

		const endDate = calculateEndDate(selectedOption, count);

		const order = {
			userId: userId,
			superLikes: superLikes,
			endDate: !isVip || extendEndDate ? endDate : null,
			uuId: selectedGift,
			clean: clean,
			extendEndDate: !isVip || extendEndDate,
		};
		await createOrder(order);
		setShowPopup(false);

		setVip(true);
		onClose();
	};

	const handleCancel = () => {
		setShowPopup(false);
	};

	const handleSave = () => {
		setShowPopup(true);
	};

	const onCloseHandle = () => {
		setShowPopup(false);
		setSuperLikes(3);
		setClean(1);
		setExtendEndDate(true);
		onClose();
	};

	const handleOptionChange = (event) => {
		const plan = event.target.value;
		setSelectedOption(plan);
		if (plan === "day") {
			setSelectedType("Дней");
		} else if (plan === "week") {
			setSelectedType("недель");
		} else if (plan === "month") {
			setSelectedType("месяцев");
		} else if (plan === "year") {
			setSelectedType("лет");
		}
	};
	const handleGiftChange = (event) => {
		const gift = event.target.value;
		setSelectedGift(gift);
	};

	const handleCountChange = (event) => {
		setCount(event.target.value);
	};

	const handleSuperLikesChange = (event) => {
		setSuperLikes(event.target.value);
	};
	const handleCleanChange = (event) => {
		setClean(event.target.value);
	};

	if (!isOpen) return null;

	return (
		<div className="PopupGift-overlay">
			<ConfirmPopup
				isOpen={showPopup}
				onConfirm={handleConfirm}
				onCancel={handleCancel}
			/>
			<div className="PopupGift-popup">
				<h2>{isVip ? "Продлить Premium" : "Подарить Premium"}</h2>
				<div className="options">
					<label>
						Тип подарка
						<select value={selectedGift} onChange={handleGiftChange}>
							<option value="premium">PREMIUM</option>
						</select>
					</label>
				</div>
				<div className="options">
					<label className="PopupGift-check">
						<input
							type="checkbox"
							checked={!isVip || extendEndDate}
							disabled={!isVip}
							onChange={(event) => setExtendEndDate(event.target.checked)}
						/>
						Продлить срок подписки
					</label>
				</div>
				<div className="options">
					<label>
						Срок действия
						<select value={selectedOption} onChange={handleOptionChange}>
							<option value="day">День</option>
							<option value="week">Неделя</option>
							<option value="month">Месяц</option>
							<option value="year">Год</option>
						</select>
					</label>
				</div>
				<div className="count-input">
					<label>
						Сколько {selectedType}
						<select value={count} onChange={handleCountChange}>
							<option value="1">1</option>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
							<option value="5">5</option>
							<option value="6">6</option>
						</select>
					</label>
				</div>
				<div className="superlikes-input">
					<label>
						Количество суперлайков
						<input
							type="number"
							value={superLikes}
							min={3}
							onChange={handleSuperLikesChange}
						/>
					</label>
				</div>
				<div className="superlikes-input">
					<label>
						Количество чистых листов
						<input
							type="number"
							value={clean}
							min={0}
							onChange={handleCleanChange}
						/>
					</label>
				</div>
				<div className="popup-buttons">
					<button onClick={handleSave} className="save-button">
						{isVip ? "Продлить" : "Подарить"}
					</button>
					<button onClick={onCloseHandle} className="cancel-button">
						Отмена
					</button>
				</div>
			</div>
		</div>
	);
};

export default PopupGift;
